import type { Movie } from "@/mocks/movies";

interface EpisodeListProps {
  movie: Movie;
  onPlay: (label: string) => void;
}

export default function EpisodeList({ movie, onPlay }: EpisodeListProps) {
  const isMovie = movie.channel === "电影";

  const labels = isMovie
    ? ["正片"]
    : Array.from({ length: movie.episodes }, (_, i) => `第${i + 1}${movie.episodeUnit}`);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-list-check-2 text-primary-600" />
          {isMovie ? "播放" : "剧集列表"}
        </h2>
        <span className="text-xs text-foreground-500">
          {isMovie ? "已上线" : `共 ${movie.episodes} ${movie.episodeUnit}`}
        </span>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2 md:grid md:grid-cols-6 md:gap-3 md:overflow-visible lg:grid-cols-8">
        {labels.map((label, i) => (
          <button
            key={label}
            type="button"
            onClick={() => onPlay(label)}
            className={`group flex h-12 shrink-0 items-center justify-center gap-1.5 rounded-md border px-4 text-sm font-medium transition-colors cursor-pointer md:w-full ${
              i === 0
                ? "border-primary-300 bg-primary-50 text-primary-700"
                : "border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            <i className="ri-play-circle-line text-base" />
            <span className="whitespace-nowrap">{isMovie ? "正片" : `${i + 1}`}</span>
          </button>
        ))}
      </div>
      <p className="mt-3 text-xs text-foreground-500">
        剧集列表用于演示，点击后将打开播放窗口演示，不提供真实视频播放。
      </p>
    </section>
  );
}